import { render, staticRenderFns } from "./musicalView.vue?vue&type=template&id=bb7edfb2&scoped=true"
import script from "./musicalView.vue?vue&type=script&lang=js"
export * from "./musicalView.vue?vue&type=script&lang=js"
import style0 from "./musicalView.vue?vue&type=style&index=0&id=bb7edfb2&prod&lang=scss&scoped=true"
import style1 from "./musicalView.vue?vue&type=style&index=1&id=bb7edfb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7edfb2",
  null
  
)

export default component.exports